/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/entry/add-jira-vendor-imports
import '@jira/platform__vendor/src/vendor-parcel.tsx';
import '@jira/platform__vendor/src/commons-parcel.tsx';

import { provideHealthcheck } from '@atlassian/jira-common-healthcheck/src/utils/healthcheck-utils/index.tsx';
import global from './global.tsx';

global.install();
provideHealthcheck();
